export { type FeedbackAdapter } from "./FeedbackAdapter";
